import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const AchievementsPage = lazy(async () => {
  const m = await import("@/features/gamification/components/achievements-page");
  return { default: m.AchievementsPage };
});

/**
 * GAMIFICATION-CORE (UI) — "Achievements": XP/nivel, racha y badges derivados del
 * feed de actividad. Opt-in y no punitivo (B2B); ligas privadas por defecto.
 */
export const achievementsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/achievements",
  component: () => (
    <Suspense fallback={null}>
      <AchievementsPage />
    </Suspense>
  ),
});
